module.exports = __webpack_public_path__ + "img/part-one-thumb_mobile.3f7b0be.jpg";